module.exports = __webpack_public_path__ + "img/ottawa_university.a051288e.webp";